<template lang="html">
  <v-container text-xs-center>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>Events</h1>
      </v-flex>
      <v-flex xs6 pa-1 v-for="(event,index) in events" :key="index">
        <v-card>
          <v-img :src="event.cover" :lazy-src="event.cover" aspect-ratio="1.5">
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate color="grey darken-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
        <v-card-title primary-title>
          <v-flex xs10>
            <h3 class="text-xs-left headline">{{event.title}}</h3>
          </v-flex>
          <v-flex xs2 text-xs-right>
            <v-icon class="pointer pa-2" color="orange">chevron_right</v-icon>
          </v-flex>
          <v-flex xs12>
          </v-flex>
            <div class="hidden-md-and-up text-xs-left only-two-lines"> {{event.description}} </div>
            <div class="hidden-md-and-down text-xs-left only-three-lines"> {{event.description}} </div>
        </v-card-title>
        <!-- <v-card-actions>
          <v-btn flat class="pa-2" color="orange">More</v-btn>
        </v-card-actions> -->
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      events: [{
        title: 'One',
        cover: 'https://cdn.vuetifyjs.com/images/cards/desert.jpg',
        description: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don\'t look even slightly believable.'
      }, {
        title: 'Two',
        cover: 'https://cdn.vuetifyjs.com/images/cards/desert.jpg',
        description: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don\'t look even slightly believable.'
      }, {
        title: 'Three',
        cover: 'https://cdn.vuetifyjs.com/images/cards/desert.jpg',
        description: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don\'t look even slightly believable.'
      }, {
        title: 'Four',
        cover: 'https://cdn.vuetifyjs.com/images/cards/desert.jpg',
        description: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don\'t look even slightly believable.'
      }]
    }
  }
}
</script>

<style lang="css" scoped>
</style>
